import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import mutation from '@/plugins/graphql/mutations/v2/user-settings-update.gql';
import UserFragment from '@/plugins/graphql/fragments/user.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
let AccountSettingDetail = class AccountSettingDetail extends Mixins(AlertMixin, ButtonLoaderMixin, FormMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.editing = false;
        this.newValue = '';
        this.email = '';
    }
    get editLabel() {
        return this.fieldType === 'password-dialog' ? 'Reset' : 'Edit';
    }
    get displayValue() {
        return this.displayedValue || this.value;
    }
    get isMobile() {
        return this.fieldType === 'mobile-field';
    }
    get isPassword() {
        return this.fieldType === 'password-dialog';
    }
    onEditing() {
        if (this.isPassword) {
            this.$emit('password:show');
            return;
        }
        this.editing = true;
    }
    onSave() {
        this.requestOnFlight();
        let input = {
            [this.fieldKey]: this.newValue,
            userUuid: this.uuid,
        };
        if (this.isMobile) {
            input = { ...input, contactDialCode: '+63' };
        }
        this.$apollo
            .mutate({
            mutation,
            variables: { input },
            update: (store, { data }) => {
                const { user } = data.userSettingUpdate;
                user.uuid = input.userUuid;
                store.writeFragment({
                    id: input.userUuid,
                    fragment: UserFragment,
                    data: user,
                    fragmentName: 'User',
                });
                this.editing = false;
                this.successNotification(`${this.label} updated`);
                this.requestDone();
            },
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.requestDone();
            this.editing = false;
        });
    }
    hasUrl() {
        const urlRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
        return !urlRegex.test(this.newValue);
    }
    valueObserver(newValue) {
        this.newValue = newValue;
    }
};
__decorate([
    Prop({ type: String, default: 'text-field' })
], AccountSettingDetail.prototype, "fieldType", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AccountSettingDetail.prototype, "fieldDisabled", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountSettingDetail.prototype, "fieldKey", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountSettingDetail.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: null })
], AccountSettingDetail.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: null })
], AccountSettingDetail.prototype, "displayedValue", void 0);
__decorate([
    Prop({ type: String, default: null })
], AccountSettingDetail.prototype, "mask", void 0);
__decorate([
    Prop({ type: String, default: '' })
], AccountSettingDetail.prototype, "uuid", void 0);
__decorate([
    Watch('value', { immediate: true })
], AccountSettingDetail.prototype, "valueObserver", null);
AccountSettingDetail = __decorate([
    Component({
        components: {
            TextField: () => import('@/components/v2/BaseTextField.vue'),
            PasswordField: () => import('@/components/v2/BaseTextField.vue'),
            MobileField: () => import('@/components/v2/BaseTextField.vue'),
            DatePicker: () => import('@/components/datepicker/Index.vue'),
            ActionButtion: () => import('@/components/action_button/Index.vue'),
        },
        validations() {
            const defaultParams = {
                required,
                invalidValue: () => this.hasUrl(),
            };
            if (this.isMobile) {
                return {
                    newValue: {
                        ...defaultParams,
                        invalidValue: (val) => val.length >= 10,
                    },
                };
            }
            return {
                newValue: defaultParams,
            };
        },
    })
], AccountSettingDetail);
export default AccountSettingDetail;
